import React from 'react';

export default class DpcCardHorizontalSection extends React.Component {

    getText(text){
        if(!text || typeof text !== "string")
            return "";

        const regex = /(( ?)<\/?(?:a)[^>]*>)|<[^>]+>( ?)/ig;
        const subst = `$1`;
        const body = text.replace(regex, subst);

        if(body.length <= 200)
            return body;
        const subString = body.substr(0, 199);
        return subString.substr(0, subString.lastIndexOf(" ")) + "...";
    }

    render(){
        return (
            <>
            <div className="col-12 col-md-6">
                <div class="card card-img">
				    <div class="img-responsive-wrapper">
                        <div class="img-responsive">
                            <figure class="img-wrapper">
                            <figcaption className="sr-only">{this.props.image?.field_didascalia}</figcaption>
                                <a href={this.props.slug} title={this.props.title}>
                                <img
                                    src={this.props.image ? this.props.image.relationships?.image.localFile?.publicURL : null}
                                    className="card-img" alt={this.props.image?.field_alt}/>
                                </a>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <article class="card-wrapper card-space">
                    <div class="card card-img">
                        <div className="card-body">
                            <h4 className="card-title">
                                <a href={this.props.slug}>
                                    {this.props.title}
                                </a>
                            </h4>
                            {this.props.body &&
                            <div className="card-text"
                                    dangerouslySetInnerHTML={{__html: this.getText(this.props.body, 100)}}/>
                            }
                        </div>
                    </div>
                </article>
            </div>
            </>
        )
    }

}
